module.exports = __webpack_public_path__ + "img/photosVehicle.af139052.jpg";